import { CellPopover } from '@components/CellPopover';
import useFormatter from '@hooks/useFormatter';
import { ICellPopover } from '@hooks/useCellPopover';
import { Box, makeStyles, Typography } from '@material-ui/core';
import { IContratoCliente } from '@model/ContratoCliente';
import React from 'react';

export type ContratoClienteCanceladoPopoverProps = {
    contratoCliente: IContratoCliente
    cellPopover: ICellPopover<IContratoCliente>
}

export function ContratoClienteCanceladoPopover ({ contratoCliente, cellPopover }: ContratoClienteCanceladoPopoverProps) {
    const formatter = useFormatter();
    const cls = useStyles();

    return (
        <CellPopover
            cellPopover={cellPopover}
        >
            <Box className={cls.root}>
                <Typography>Data do Cancelamento: {formatter.toDateTime(contratoCliente.dataCancelamento)}</Typography>
                <Typography>{contratoCliente.justificativaCancelamento}</Typography>
            </Box>
        </CellPopover>
    )
}

const useStyles = makeStyles(theme => ({
    root : {
        padding: theme.spacing(2)
    }
}));